import { useApplicationPageAggregatedData } from "./aggregatedData";
import { parse } from "../../../utils/parse";
import { findByType } from "../../../data";
import { ApplicationRequirementEvaluationStatus } from "../../../types/ApplicationRequirement";
export function useApplicationRequirementEvaluationStatus() {
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(data) {
        var _findByType;
        return parse(ApplicationRequirementEvaluationStatus.nullish(), (_findByType = findByType(data.included, 'application_requirement_evaluation_status')) === null || _findByType === void 0 ? void 0 : _findByType.attributes);
      }
    }),
    data = _useApplicationPageAg.data;
  return {
    applicationRequirementEvaluationStatus: data
  };
}